export default function NeroLoader() {
    return (
        <div className="modal-overlay bg-black bg-body-tertiary">
            <div className="infinity-10"></div>
        </div>
    )
}